import { Box, Typography, Link, Container } from '@mui/material';

interface LandingPageFooterProps {
  primaryColor: string;
}

export const LandingPageFooter = ({ primaryColor }: LandingPageFooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: 'grey.900',
        color: 'grey.400',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2">
            &copy; {currentYear} All rights reserved
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="body2">
              Powered by
            </Typography>
            <Link
              href="https://elevair.app"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: primaryColor,
                textDecoration: 'none',
                fontWeight: 600,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Elevair
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
